// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__CYakh","row":"Footer_row__eqlt5"};